export default "__VITE_ASSET__DbPzuUjz__"